import { EventGraphNode, EventHandlerBase, Primitive, RenderBucketItem, RenderItemType } from "pytha2";
import { BufferGeometry, Float32BufferAttribute, LineDashedMaterial, LineSegments, Material, Mesh, Object3D, Points, Vector3 } from "three";
import { Curve, GeometryBase, Point, Surface } from "tnbase";

interface MyRenderBucketItem extends RenderBucketItem {
    material: Material
}

/**
 * 鼠标跟随移动临时轴网
 */
export class EventHandlerMoveTempAxisNet extends EventHandlerBase {

    _copyEntitiyMap: { [key: string]: MyRenderBucketItem } = {}

    _init: boolean = false;

    constructor(node: EventGraphNode) {
        super(node);
    }

    run(): boolean {
        // console.log('鼠标跟随移动临时轴网 run');

        if (Object.keys(this._copyEntitiyMap)?.length === 0) {
            const selectPrimitives = this.node.graph.cache.data['tempPrimitives'];
            this.generateTempRenderItems(selectPrimitives);
            if (Object.keys(this._copyEntitiyMap)?.length > 0) {
                // 标记生成的轴网为needDelete 获取了就把他删掉
                selectPrimitives?.forEach(pri => {
                    let entity = this.getPythaStorage().primitiveStore.tempPrimitiveDict[pri.uuid];
                    if (entity) {
                        entity.needDelete = true;
                    }
                })
            }
            this._init = true;
        }
        let currentPoint: Point = this.node.graph.cache.pointerMove.point;

        //通过当前点更新临时图元
        const x = currentPoint.x - this.node.graph.cache.data['basePoint'].x;
        const y = currentPoint.y - this.node.graph.cache.data['basePoint'].y;
        const z = currentPoint.z - this.node.graph.cache.data['basePoint'].z;
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            if (mapItem.object == null) continue;
            mapItem.object.position.set(x, y, z);
        }
        return true;
    }


    dispose(): void {
        // console.log('dispose dispose', this._copyEntitiyMap);
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            if (mapItem.object == null) continue;
            if (mapItem.object.parent) {
                mapItem.object.parent.remove(mapItem.object);
            }
        }

        // let _copyEntitiyMap = this.node.graph.cache.data['_copyEntitiyMap'];
        // console.log('dispose dispose', _copyEntitiyMap);
        // for (let key in _copyEntitiyMap) {
        //     let mapItem = _copyEntitiyMap[key];
        //     if (mapItem.object == null) continue;
        //     if (mapItem.object.parent) {
        //         mapItem.object.parent.remove(mapItem.object);
        //     }
        // }
    }

    /**
     * 生成临时渲染对象
     */
    generateTempRenderItems(selectPrimitives: Primitive[]) {
        const storage = this.getPythaStorage();

        for (let i = 0; i < selectPrimitives.length; i++) {
            let primitive = selectPrimitives[i];
            Object.keys(primitive.renderItemDict).forEach(renderKey => {
                let renderItem = primitive.renderItemDict[renderKey]
                const key = renderItem.lastRenderKey;
                let bucket = storage.renderStore.objectRenderBucket[key];
                if (bucket == null) return;
                let renderMapItem = bucket.renderBucketItems[renderItem.renderGeometryBucketIndex];
                if (renderMapItem == null) return;
                const start = renderItem.start;
                const size = renderItem.size;
                const mat = bucket.material;
                let copyRenderMapItem = this._copyEntitiyMap[key];
                if (copyRenderMapItem == null) {
                    copyRenderMapItem = {
                        material: mat,
                        positions: [],
                        colors: [],
                        uvs: [],
                        renderType: renderMapItem.renderType,
                        needRegenerate: false,
                        hidden: false
                    }
                    this._copyEntitiyMap[key] = copyRenderMapItem;
                }

                if (renderMapItem.buffer == null) return;
                let positions = renderMapItem.buffer.attributes?.position?.array;
                let colors = renderMapItem.buffer.attributes?.color?.array;

                if (positions == null || colors == null) return;

                for (let index = 0; (index < size) && (index + start) < positions.length; index++) {
                    copyRenderMapItem.positions.push(positions[index + start]);
                    copyRenderMapItem.colors.push(colors[index + start]);
                }
            })
        }

        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            let geo = new BufferGeometry();
            geo.setAttribute('position', new Float32BufferAttribute(mapItem.positions, 3));
            if (mapItem.uvs?.length > 0) {
                geo.setAttribute('uv', new Float32BufferAttribute(mapItem.uvs, 2));
            } else {
                let colorAttribute = new Float32BufferAttribute(mapItem.colors, 3);
                geo.setAttribute('color', colorAttribute);
            }
            geo.computeBoundingBox();
            geo.computeVertexNormals();
            switch (mapItem.renderType) {
                case 'Line':
                    let line = new LineSegments(geo, mapItem.material);
                    storage.viewportStore.scene.add(line)
                    mapItem.object = line;
                    break;
                case 'Mesh':
                    let mesh = new Mesh(geo, mapItem.material);
                    storage.viewportStore.scene.add(mesh);
                    mapItem.object = mesh;

                    break;
                case 'Point':
                    let point = new Points(geo, mapItem.material);
                    storage.viewportStore.scene.add(point);
                    mapItem.object = point;
                    break;

                default:
                    break;
            }
        }
    }
    _point = new Vector3();
}